import './About.scss';
import {motion} from 'framer-motion';
// import {useState, useEffect} from 'react';
import { useEffect, useState } from 'react';
import {client, urlFor} from '../../client';

import { AppWrap, MotionWrap } from '../../wrapper';

const About = () => {

    const[abouts, setAbouts] = useState([]);

    useEffect(() => {

        
fetch('https://i1ndq4tu.api.sanity.io/v2021-10-21/data/query/production?query=*%5B_type%20%3D%3D%20%22abouts%22%5D')
.then((data)=>console.log(data));
        const query = '*[_type == "abouts"]';
    
        client.fetch(query).then((data) => {
            setAbouts(data);
          });
      }, []);


    return <>
    <div className="app__about" id="about">
        <h2 className="head-text">I Know That <span>Great Apps</span><br/>means <span>Great Business</span></h2>
        <div className="app__profiles">
            {abouts.map((about, index)=>(
                <motion.div
                whileInView={{opacity: 1, x:[-200, 0], type: 'easeIn'}}
                whileHover={{scale: 1.1}}
                transition={{duration: 0.5, type: 'tween'}}
                className="app__profiles-item"
                key={about.title+index}
                >
                    <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
                </motion.div>
            ))}
        </div>
    </div>
    </>
}
 
export default AppWrap(
    MotionWrap(About, 'app__about'),
    'about',
    'app__whitebg',
  );